import { getMediaIdFromResponse, getMediaPreviewUrl } from '@/lib/mediaImageField';
import { ImageUploadDropzone as BaseImageUploadDropzone } from '@startupquickstart/frontend';

interface ImageUploadDropzoneProps {
  value?: string;
  onChange: (mediaId: string | undefined) => void;
  label?: string;
  maxSizeMB?: number;
  required?: boolean;
  error?: string;
  /** Target aspect ratio as width/height (e.g. 4/3). Shows warning/error if image doesn't match. */
  targetAspectRatio?: number;
}

/**
 * Tours-specific image upload that returns media IDs instead of URLs.
 * Wraps the shared ImageUploadDropzone with media-ID handling. The module-level
 * helpers are stable references, so they don't re-trigger effects per render.
 */
export function ImageUploadDropzone(props: ImageUploadDropzoneProps) {
  return (
    <BaseImageUploadDropzone
      {...props}
      getPreviewUrl={getMediaPreviewUrl}
      getValueFromResponse={getMediaIdFromResponse}
    />
  );
}
